export const Config = {
  API_URL: "https://pg-portuguese-app-be.justsnap.eu/api",
  // hardCodedToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjdXN0b21lclRva2VuIjoiZWZjZDEyYTUtZmIyNS00MDk3LWFjMDAtMGVjODI1MzhmYzVlIiwiaWF0IjoxNjQ1NTA2NjQ3fQ.vGZFBHt-GOA6DwsMLgkK9SSkhTUdQBdUf9iIvWUOC7Q',
  API_KEY: "app",
  API_PASS: "PJ7tPQ0vaRypSp62",
  APPLE_APP_ID: "1622364940",
};
